/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Destination } from './Destination';
import {
    DestinationFromJSON,
    DestinationFromJSONTyped,
    DestinationToJSON,
} from './Destination';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';

/**
 * 
 * @export
 * @interface RoutePost
 */
export interface RoutePost {
    /**
     * 
     * @type {Source}
     * @memberof RoutePost
     */
    source?: Source;
    /**
     * 
     * @type {Destination}
     * @memberof RoutePost
     */
    destination?: Destination;
}

/**
 * Check if a given object implements the RoutePost interface.
 */
export function instanceOfRoutePost(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RoutePostFromJSON(json: any): RoutePost {
    return RoutePostFromJSONTyped(json, false);
}

export function RoutePostFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoutePost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': !exists(json, 'source') ? undefined : SourceFromJSON(json['source']),
        'destination': !exists(json, 'destination') ? undefined : DestinationFromJSON(json['destination']),
    };
}

export function RoutePostToJSON(value?: RoutePost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': SourceToJSON(value.source),
        'destination': DestinationToJSON(value.destination),
    };
}

